if (!customElements.get("parallax-section")) {
  customElements.define(
    "parallax-section",
    class Parallax extends HTMLElement {
      constructor() {
        super();
        this.images = this.querySelectorAll(".wt-parallax__img");
      }

      connectedCallback() {
        this.init();
      }

      decorateImages() {
        const listItems = this.querySelectorAll(".wt-parallax__gallery__item");
        listItems.forEach((item, index) => {
          const image = item.querySelector(".wt-parallax__img");
          if (image) {
            image.classList.add(
              `wt-parallax__img--${index % 2 === 0 ? "odd" : "even"}`,
            );
          }
        });
      }

      // --- NOWA FUNKCJA: USTAWIANIE WIELKOŚCI NA SZTYWNO ---
      applySizes() {
        const isMobile = window.innerWidth < 900;
        
        this.images.forEach((image) => {
          // Pobieramy wartości z atrybutów data- (dodanych w pliku Liquid)
          const mobileWidth = image.dataset.mobileWidth;
          const desktopWidth = image.dataset.desktopWidth;

          if (isMobile && mobileWidth) {
            image.style.width = `${mobileWidth}px`;
            image.style.maxWidth = 'none'; // Zdejmujemy blokady motywu
          } else if (!isMobile && desktopWidth) {
            image.style.width = `${desktopWidth}px`;
            image.style.maxWidth = 'none';
          }
        });
      }

      rotateOnScroll() {
        const { images } = this;
        const maxRotation = parseInt(this.dataset.rotation, 10) || 5;

        // Używamy arrow function żeby zachować kontekst 'this'
        const handleScroll = () => {
          images.forEach((image) => {
            const imageRect = image.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (imageRect.top < windowHeight) {
              let visiblePart = windowHeight - imageRect.top;
              let visiblePercent = (visiblePart / windowHeight) * 100;
              let rotationDegree = Math.min(
                (visiblePercent / 100) * maxRotation,
                maxRotation,
              );

              if (image.classList.contains("wt-parallax__img--odd")) {
                rotationDegree *= -1;
              }

              window.requestAnimationFrame(() => {
                image.style.transform = `translate3d(0px, 0px, 0px) rotate(${rotationDegree}deg)`;
              });
            }
          });
        };

        document.addEventListener("scroll", handleScroll);
        // Wywołaj raz na starcie, żeby ustawić pozycję
        handleScroll();
      }

      init() {
        this.decorateImages();
        this.applySizes(); // Ustaw wielkość przy starcie
        this.rotateOnScroll();

        // Aktualizuj wielkość przy zmianie rozmiaru okna (np. obrót telefonu)
        window.addEventListener('resize', () => {
           this.applySizes();
        });
      }
    },
  );
}